import { render, staticRenderFns } from "./MallDecorateV2.vue?vue&type=template&id=3590f150&scoped=true"
import script from "./MallDecorateV2.vue?vue&type=script&lang=js"
export * from "./MallDecorateV2.vue?vue&type=script&lang=js"
import style0 from "./MallDecorateV2.vue?vue&type=style&index=0&id=3590f150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3590f150",
  null
  
)

export default component.exports